import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Home, Map, Wallet, Menu, WifiOff } from "lucide-react";
import { useOnline } from "@/components/shared";

const NAV = [
  { icon: Home, label: "Home", to: "/app" },
  { icon: Map, label: "Map", to: "/app/safe-points" },
  { icon: Wallet, label: "Wallet", to: "/app/wallet" },
  { icon: Menu, label: "More", to: "/app/more" },
];

export default function MasqLayout() {
  const nav = useNavigate();
  const loc = useLocation();
  const online = useOnline();

  return (
    <div className="cs-shell" style={{ background: "var(--cs-bg)", paddingBottom: 84 }}>
      {!online && (
        <div className="sticky top-0 z-40 flex items-center justify-center gap-2 py-2 text-xs font-semibold"
          style={{ background: "var(--cs-amber)", color: "#000" }} data-testid="offline-banner">
          <WifiOff size={14} /> You're offline. Showing saved safety information.
        </div>
      )}
      <Outlet />

      <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full z-40"
        style={{ maxWidth: 480, background: "rgba(20,20,27,0.92)", backdropFilter: "blur(16px)", borderTop: "1px solid var(--cs-border)" }}>
        <div className="grid grid-cols-4">
          {NAV.map((n) => {
            const active = loc.pathname === n.to;
            return (
              <button key={n.to} data-testid={`masq-nav-${n.label.toLowerCase()}`} onClick={() => nav(n.to)}
                className="cs-tap flex flex-col items-center gap-1 py-3"
                style={{ color: active ? "var(--cs-magenta)" : "var(--cs-fg2)" }}>
                <n.icon size={22} />
                <span className="text-[10px] font-semibold">{n.label}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
